export default "__VITE_ASSET__DcH21F7H__"